import { Close } from '@mui/icons-material';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';

import LogCard from '@/entities/log/ui/LogCard/LogCard';
import { formatDurationRussian } from '@/utils/formatDurationRussian';

import type { OtherLogsDetailPanelProps } from '../../types';

import s from './OtherLogsDetailPanel.module.scss';

const DRAWER_WIDTH = 360;

const OtherLogsDetailPanel: React.FC<OtherLogsDetailPanelProps> = observer(
  ({ open, group, onClose, onEditLog }) => {
    const totalMinutes = useMemo(() => {
      if (!group) return 0;
      return group.logs.reduce((sum, log) => sum + log.durationMinutes, 0);
    }, [group]);

    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        variant="temporary"
        sx={{
          '& .MuiDrawer-paper': {
            width: DRAWER_WIDTH,
            boxSizing: 'border-box',
          },
        }}
      >
        <div className={s.detail_panel}>
          <div className={s.detail_panel__header}>
            <Typography variant="subtitle1" fontWeight={600}>
              Логи за {group?.date ?? ''}
            </Typography>
            <IconButton size="small" onClick={onClose}>
              <Close fontSize="small" />
            </IconButton>
          </div>

          <div className={s.detail_panel__list}>
            {group?.logs.map((log) => (
              <LogCard key={log.id} log={log} onOpenDetails={onEditLog} />
            ))}
          </div>

          {group && group.logs.length > 0 && (
            <Box className={s.detail_panel__total}>
              <Typography variant="body2" color="text.secondary">
                Итого: {formatDurationRussian(totalMinutes)}
              </Typography>
            </Box>
          )}
        </div>
      </Drawer>
    );
  },
);

export { OtherLogsDetailPanel };
